export default __webpack_public_path__ + "static/media/cli-serra-dos-manacas.dd671212.png";